module.exports = __webpack_public_path__ + "static/media/27OCHA12.b435db5f.jpg";